/**
 * Parcels Details
 */

// React
import React, { FC, useContext, useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';

// Context
import AuthContext from '../../authContext';

// Redux
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Store } from '../../redux/reducers';
import {
  getInventoryItemsWithSerialAction,
  getInventoryItemsWithStatusAction,
  getParcelInventoryItemsAction,
  getParcelsWithIdAction,
  updateInventoryItemsActions,
  updateMultiInventoryItemsStatusAction,
  updateParcelsStatusActions,
} from '../parcels/actions';

// Selector
import { createStructuredSelector } from 'reselect';
import {
  makeSelectError,
  makeSelectInventoryItemsCount,
  makeSelectInventoryItemsError,
  makeSelectInventoryItemsList,
  makeSelectInventoryItemsLoading,
  makeSelectInventoryItemsWithSerialError,
  makeSelectInventoryItemsWithSerialList,
  makeSelectInventoryItemsWithSerialLoading,
  makeSelectInventoryItemsWithStatusError,
  makeSelectInventoryItemsWithStatusList,
  makeSelectInventoryItemsWithStatusLoading,
  makeSelectLoading,
  makeSelectParcel,
} from '../parcels/selectors';

//UI
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import theme from '../../theme';
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogTitle,
  Divider,
  FormControl,
  Grid,
  IconButton,
  MenuItem,
  Paper,
  Select,
  TextField,
  Typography,
  Collapse,
} from '@material-ui/core';

// Icon
import Icon from '@mdi/react';
import {
  mdiAccountOutline,
  mdiAlertCircle,
  mdiArchiveOutline,
  mdiArrowRight,
  mdiBarcode,
  mdiCalendar,
  mdiCalendarClock,
  mdiCheck,
  mdiChevronDown,
  mdiChevronLeft,
  mdiChevronUp,
  mdiCityVariant,
  mdiClose,
  mdiCounter,
  mdiFormatListCheckbox,
  mdiKeyOutline,
  mdiMapMarkerOutline,
  mdiPackage,
  mdiPackageVariantClosed,
  mdiPhoneOutline,
  mdiPrinter,
  mdiStateMachine,
  mdiTextBoxSearch,
  mdiWarehouse,
} from '@mdi/js';

// Components
import ListParcelItems from './list';
import Can from '../../components/Can';
import Pagination from '@material-ui/lab/Pagination';
import Modal from '../../components/Modal';
import { useForm } from 'react-hook-form';
import LabelList from './components/labelsList';

// Rules

// Helper
import {
  formaterPhoneNumber,
  translateDeliveryType,
  translateParcelsStatus,
} from '../../utils/helpers';
import jMoment from 'moment-jalaali';

// Type
import { Status } from '../orders/interfaces';
import { Product, Props, SelectorProps } from './interfaces';
import handleError from '../../utils/handleError';
import { updateMultiInventoryItemsStatus } from '../parcels/saga';
import { multiStatusBody } from '../parcels/interfaces';
import PaginationNumber from '../../components/PaginationNum';

//
import Client from 'client-sdk/src/client';
import { UpdateInventoryItemsRequestBuilder } from 'client-sdk/src/parcels/parcels';

export type Input = {
  serial: string;
}

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& > *': {
        '@media (max-width: 768px)': {
          margin: theme.spacing(0),
        },
      },
    },
    paper: {
      marginTop: '16px',
      marginBottom: '16px',
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      border: '1px solid #ddd',
      borderRadius: '4px',
    },
    allocateIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingTop: '10px',
      marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '.5',
        backgroundColor: '#f3ab3e',
      },
    },
    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 500,
    },
    icon: {
      marginRight: theme.spacing(1),
    },
    divider: {
      width: '98%',
      margin: '10px auto',
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 400,
      color: '#8A8A8A',
      marginRight: '10px',
    },
    headerBox: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '28px',
    },
    contentlabelTitle: {
      position: 'relative',
      color: theme.palette.gray.light,
      marginLeft: '40px',
      fontSize: '14px',
      fontWeight: 500,
      '&:before': {
        content: '"-"',
        position: 'absolute',
        left: '-20px',
      },
    },
    loading: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    changStatusIcon: {
      marginRight: '10px',
      position: 'absolute',
    },
    changStatusBox: {
      display: 'flex',
      textAlign: 'left',

      fontWeight: 400,
      fontSize: '14px',
    },
    renderValue: {
      paddingLeft: '32px',
    },
    radioGroup: {
      margin: '-8px 0',
    },
    radioGroupItem: {
      borderBottom: '1px solid #D8D8D8',
      marginRight: '-8px',
      padding: '8px 16px',
      '&:last-child': {
        borderBottom: '0px',
      },
    },
    cancelTitle: {
      fontSize: '16px',
      fontWeight: 500,
      textAlign: 'justify',
      lineHeight: 2,
      marginBottom: theme.spacing(3),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    collapseIcon: {
      marginTop: '-36px',
      textAlign: 'center',
      position: 'relative',
      width: '100%',
      // marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '40px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '40px',
        borderRadius: '50%',
        backgroundColor: theme.palette.secondary.main,
        border: '5px solid white',
      },
    },
    editIcon: {
      textAlign: 'center',
      position: 'relative',
      marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.blue.main,
      },
    },
    showCount: {
      '& .MuiSelect-icon': {
        color: '#DFA01F',
      },
    },
    card: {
      minWidth: '250px',
      display: 'flex',
      background: '#fff',
      padding: '8px 4px',
      borderRadius: '4px',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
    },
    cardItem: {
      margin: '0 4px',
      flex: 1,
    },
  })
);

const Details: FC<Props> = (props: Props): React.ReactElement => {
  const history = useHistory();
  const [selected, setSelected] = React.useState<string[]>([]);
  const authContext = useContext(AuthContext);
  const [openSize, setOpenSize] = React.useState(false as boolean);
  const [openItemsNotFound, setOpenItemsNotFound] = useState(false as boolean);
  const [openBarcode, setOpenBarcode] = useState(false as boolean);
  const [checkBarcodeDialogClosed, setCheckBarcodeDialogClosed] = useState(
    false as boolean
  );
  const [changeParcelStatusDialog, setChangeParcelStatusDialog] = useState(
    false as boolean
  );
  const [
    openDialogForChangeParcelStatus,
    setOpenDialogForChangeParcelStatus,
  ] = useState(false as boolean);
  const [
    openDialogForItemsNotRegistered,
    setOpenDialogForItemsNotRegistered,
  ] = useState(false as boolean);
  const [openRegisterItems, setOpenRegisterItems] = useState(false as boolean);
  const [statusChanged, setStatusChanged] = useState(false as boolean);
  const [id, setId] = useState(-1 as number);
  const [description, setDescription] = useState('');
  const [product, setProduct] = useState({} as Product);
  const { register, errors, handleSubmit, getValues, setValue, watch } = useForm<Input>({
    defaultValues: {
      serial: ''
    },
  });
  const [filtersValues, setFiltersValues] = useState({
    page: 0,
    size: 100,
  } as any);
  const [printModal, setPrintModal] = useState(false as boolean);
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const token = localStorage.getItem('token') || '';

  const handleCollapse = () => {
    setOpen(!open);
  };

  const handleCloseSelect = () => {
    setOpenSize(false);
  };

  const handleCloseDialogForItemsNotRegistered = () => {
    setOpenDialogForItemsNotRegistered(false);
  };

  const handleCloseDialogForChangeParcelStatus = () => {
    setOpenDialogForChangeParcelStatus(false);
  };

  const handleSetParcelStatusFunc = (status: string) => {
    handleSetParcelStatus(status);
  };

  const handleSetParcelStatus = (status: string) => {
    if (status === 'REGISTERED') setDescription('');
    props.updateParcelsStatusDispatch({
      id: props.match.params.id,
      body: { status: status.replace(/'/g, '"'), description: description },
      pagination: {
        ...filtersValues,
      },
      callback: () => {
        setStatusChanged(!statusChanged);
        history.push('/parcels-warehouse-operator');
      },
    });
    setOpenDialogForItemsNotRegistered(false);
    setOpenDialogForChangeParcelStatus(false);
  };

  const handleOpenConfirmDisable = (item: Product, link = false) => {
    if (link) {
      if (item.status !== 'REGISTERED') {
        setStatusChanged(!statusChanged);
        handleSinglePrint(item)
          .then(_ => {
            const win = window.open(`${link}`, '_blank')!;
            win.focus();
          })
          .catch(err => {
          });
        return;
      }
      const win = window.open(`${link}`, '_blank')!;
      win.focus();
    } else {
      setId(item.id);
      setProduct(item);
    }
  };

  const checkSerial = (data: any) => {
    props.getInventoryItemsWithSerialActionDispatch({
      ...filtersValues,
      serialNumber: { equals: data.serial },
      parcelId: { equals: props.match.params.id },
      callback: () => {
        setValue('serial', '')
      }
    });
  };

  const handleAllocateUserFunc = () => {
    const inventoryItem = product.id
      ? product
      : props.inventoryItemsWithSerial[0];
    props.updateInventoryItemsStatusDispatch({
      id: id !== -1 ? id : props.inventoryItemsWithSerial[0]?.id,
      body:
        inventoryItem.status !== 'REGISTERED'
          ? '"REGISTERED"'
          : '"NOT_REGISTERED"',
      ...filtersValues,
      callback: () => {
        setStatusChanged(!statusChanged);
      },
    });
    setOpenRegisterItems(false);
  };

  const getInventoryItemsWithStatus = async () => {
    await props.getInventoryItemsWithStatusActionDispatch({
      parcelId: { equals: props.match.params.id },
      status: { notIn: 'REGISTERED' },
      ...filtersValues,
    });
    setChangeParcelStatusDialog(true);
  };

  const handleChangeParcelStatus = () => {
    if (props.inventoryItemsWithStatus.length !== 0) {
      setOpenDialogForItemsNotRegistered(true);
    } else {
      setOpenDialogForChangeParcelStatus(true);
    }
  };

  const handleChangeSizePage = (event: React.ChangeEvent<{ value: unknown }>) => {
    setFiltersValues({ ...filtersValues, page: 0, size: event.target.value });
  };
  const handleChangePage = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setFiltersValues({ ...filtersValues, page: page - 1 });
  };

  useEffect(() => {
    const { page, size } = filtersValues;
    const { id } = props.match.params;
    props.getParcelWithIdActionDispatch(id);
    props.getParcelInventoryItemsActionDispatch({
      ...filtersValues,
      parcelId: { equals: id },
      page,
      size,
      sort: 'sku.product.name,id,asc',
    });
  }, [statusChanged, filtersValues]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    handleCloseBarcode(true);
  }, [props.inventoryItemsWithSerial]);

  useEffect(() => {
    if (changeParcelStatusDialog) handleChangeParcelStatus();
  }, [props.inventoryItemsWithStatus]);

  useEffect(() => {
    if (product.id) {
      handleAllocateUserFunc();
    }
  }, [product]);

  const handleClose = () => {
    setOpenRegisterItems(false);
  };

  const handleCloseItemsNotFound = () => {
    setOpenItemsNotFound(false);
  };

  const handleCloseBarcode = (setRegistered: boolean) => {
    //setOpenBarcode(false);
    setValue('serial', '');
    if (setRegistered && props.inventoryItemsWithSerial.length !== 0) {
      setId(-1);
      setProduct({} as Product);
      // setOpenRegisterItems(true);
      handleAllocateUserFunc();
    }
  };

  const handleClosePrintModal = () => {
    setPrintModal(false);
  };

  const handleOpenPrintModal = () => {
    setPrintModal(true);
  };

  const handleClick = (
    event: React.ChangeEvent<HTMLInputElement>,
    id: string
  ) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected: string[] = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };

  const handleSinglePrint = async (item: Product) => {
    try {
      return await props.updateInventoryItemsStatusDispatch({
        id: item.id,
        body: '"REGISTERED"',
        ...filtersValues,
      });
    } catch (error) {
      throw error;
    }
  };

  const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      const newSelected = props.inventoryItems
        .filter((el: any) => el.status !== 'REGISTERED')
        .map((n: any) => n.id);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  const registerAllInventoryItems = async (ids: number[]) => {
    try {
      const request = new UpdateInventoryItemsRequestBuilder()
        .data({
          ids: ids,
        })
        .build();
      const client = new Client(token);
      await client.execute(request);
    } catch (err) {
      //err
    }
  };

  const handleClickPrint = () => {
    registerAllInventoryItems(selected);
    props.history.push(
      `/print-labels/${props.match.params.id}?items=${selected.join(',')}`
    );
  };

  const handleChangePageNum = (pageNumber: number) => {
    setFiltersValues({ ...filtersValues, page: pageNumber });
  };

  const handleFilterStatus = (status: string) => {
    if (filtersValues?.['status.equals'] === status) {
      setFiltersValues((prevState: any) => ({
        ...prevState,
        'status.equals': undefined,
      }));
      return;
    }
    setFiltersValues((prevState: any) => ({
      ...prevState,
      'status.equals': status,
    }));
  };

  return (
    <div className={classes.root}>
      <div className={classes.headerBox}>
        <Typography variant="h6" component="h2">
          {`
        جزيیات محموله 
        ${props.parcel.destinationName}
        `}
        </Typography>
        <span className={classes.contentlabelTitle}>{props.parcel.id}</span>
      </div>

      <Grid
        container
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <Button
          aria-label="details"
          size="medium"
          onClick={() => window.history.back()}
        >
          <Icon path={mdiArrowRight} size={1} className={classes.icon} />
          {'بازگشت'}
        </Button>

        <Can
          perform="parcel:inventory-items"
          role={authContext.user.role}
          yes={() => (
            <Link
              to={`/parcels/receipts/${props.parcel.id}`}
              target="_blank"
              style={{ textDecoration: 'none' }}
            >
              <Button
                variant="contained"
                color="secondary"
                startIcon={<Icon path={mdiPrinter} size={1} />}
              >
                {'چاپ رسید'}
              </Button>
            </Link>
          )}
        />
      </Grid>
      <Paper elevation={3} className={classes.paper} variant="elevation" square>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiCityVariant} size={1} className={classes.icon} />
                {'نام شرکت:  '}
              </span>
              <span>{props.parcel.partnerName}</span>
            </div>
          </Grid>

          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiCounter} size={1} className={classes.icon} />
                {'تعداد آیتم های محموله:  '}
              </span>

              <span>{props.inventoryItemsCount}</span>
            </div>
          </Grid>

          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiPackage} size={1} className={classes.icon} />
                {'تعداد کارتن:  '}
              </span>

              <span>{props.parcel.boxCount}</span>
            </div>
          </Grid>

          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiCalendar} size={1} className={classes.icon} />
                {'تاریخ تحویل به انبار:  '}
              </span>
              <span>
                <span>
                  {props.parcel.shippingDate &&
                    `${jMoment(props.parcel.deliveryDate, 'YYYY/MM/DD')
                      .locale('fa')
                      .format('jYYYY/jMM/jDD')}`}
                </span>
              </span>
            </div>
          </Grid>
          <Divider className={classes.divider} />
          <div className={classes.collapseIcon}>
            <IconButton onClick={handleCollapse}>
              <Icon
                path={open ? mdiChevronUp : mdiChevronDown}
                color="white"
                size={1}
              />
            </IconButton>
          </div>

          <Collapse in={open} timeout="auto" unmountOnExit>
            <Grid style={{ margin: 0 }} xs={12} container spacing={3}>
              <Grid item xs={12} sm={3}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiAccountOutline}
                      size={1}
                      className={classes.icon}
                    />
                    {'نام مسئول حمل:  '}
                  </span>

                  <span>{props.parcel.agentName}</span>
                </div>
              </Grid>

              <Grid item xs={12} sm={3}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiPhoneOutline}
                      size={1}
                      className={classes.icon}
                    />
                    {'شماره همراه مسئول حمل:  '}
                  </span>
                  <span>
                    {formaterPhoneNumber(props.parcel.agentPhoneNumber)}
                  </span>
                </div>
              </Grid>

              <Grid item xs={12} sm={3}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiCalendar}
                      size={1}
                      className={classes.icon}
                    />
                    {'تاریخ ثبت محموله:  '}
                  </span>
                  <span>
                    <span>
                      {props.parcel.deliveryDate &&
                        `${jMoment(props.parcel.shippingDate, 'YYYY/MM/DD')
                          .locale('fa')
                          .format('jYYYY/jMM/jDD')}`}
                    </span>
                  </span>
                </div>
              </Grid>

              <Grid item xs={12} sm={3}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiFormatListCheckbox}
                      size={1}
                      className={classes.icon}
                    />
                    {'نوع ارسال:  '}
                  </span>
                  <span>
                    {translateDeliveryType(props.parcel.deliveryType)}
                  </span>
                </div>
              </Grid>

              <Divider className={classes.divider} />

              <Grid item xs={12} sm={3}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiKeyOutline}
                      size={1}
                      className={classes.icon}
                    />
                    {'شناسه محموله:  '}
                  </span>

                  <span>{props.parcel.id}</span>
                </div>
              </Grid>
              <Grid item xs={12} sm={3}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiWarehouse}
                      size={1}
                      className={classes.icon}
                    />
                    {'انبار مقصد:  '}
                  </span>

                  <span>{props.parcel.destinationName}</span>
                </div>
              </Grid>
              <Grid item xs={12} sm={3}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiCalendarClock}
                      size={1}
                      className={classes.icon}
                    />
                    {'بازه تحویل محموله:  '}
                  </span>
                  <span>
                    <span>
                      {props.parcel.deliveryStartTime &&
                        jMoment(props.parcel.deliveryStartTime, 'hh:mm')
                          .locale('fa')
                          .format('HH:mm')}
                      {' - '}
                      {props.parcel.deliveryEndTime &&
                        jMoment(props.parcel.deliveryEndTime, 'hh:mm')
                          .locale('fa')
                          .format('HH:mm')}
                    </span>
                  </span>
                </div>
              </Grid>

              <Grid item xs={12} sm={3}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiStateMachine}
                      size={1}
                      className={classes.icon}
                    />
                    {'وضعیت تحویل :  '}
                  </span>
                  <span>{translateParcelsStatus(props.parcel.status)}</span>
                </div>
              </Grid>
              <Divider className={classes.divider} />
              <Grid item xs={12}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiMapMarkerOutline}
                      size={1}
                      className={classes.icon}
                    />
                    {'آدرس انبار مقصد :  '}
                  </span>
                  <span>{props.parcel.destinationAddress}</span>
                </div>
              </Grid>
            </Grid>
          </Collapse>
        </Grid>
      </Paper>
      <Grid
        style={{ marginTop: '30px', marginBottom: '20px' }}
        container
        alignItems="center"
        justify="space-between"
      >
        <div className={classes.card}>
          <div className={classes.cardItem}>
            {filtersValues?.status}
            <Button
              fullWidth
              color="secondary"
              size="medium"
              variant={
                filtersValues?.['status.equals'] === 'REGISTERED'
                  ? 'contained'
                  : undefined
              }
              onClick={() => {
                handleFilterStatus('REGISTERED');
              }}
            >
              رجیستر شده
            </Button>
          </div>
          <div className={classes.cardItem}>
            <Button
              fullWidth
              color="secondary"
              size="medium"
              variant={
                filtersValues?.['status.equals'] === 'NOT_REGISTERED'
                  ? 'contained'
                  : undefined
              }
              onClick={() => {
                handleFilterStatus('NOT_REGISTERED');
              }}
            >
              رجیستر نشده
            </Button>
          </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Can
            perform="/print-labels/:id"
            role={authContext.user.role}
            yes={() => (
              <Button
                variant="contained"
                color="secondary"
                size="large"
                startIcon={<Icon path={mdiPrinter} size={1} />}
                onClick={handleOpenPrintModal}
              >
                {'چاپ سریال'}
              </Button>
            )}
          />
          <Button
            variant="contained"
            color="secondary"
            size="large"
            style={{ marginRight: '20px' }}
            startIcon={<Icon path={mdiBarcode} size={1} />}
            onClick={() => {
              setOpenBarcode(true);
            }}
          >
            {'چک کردن بارکد'}
          </Button>
        </div>
      </Grid>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          {props.inventoryItemsLoading ? (
            <div className={classes.loading}>
              <CircularProgress />
            </div>
          ) : (
            props.inventoryItems && (
              <ListParcelItems
                parcelId={props.match.params.id}
                operatorId={props.parcel.operatorId}
                handleOpenConfirmDisable={handleOpenConfirmDisable}
                data={props.inventoryItems}
              />
            )
          )}
        </Grid>
        <Grid id="showFilter" item xs={12} sm={6}>
          {props.inventoryItems && (
            <FormControl
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
              }}
            >
              <div style={{ marginLeft: '10px', color: '#8a8a8a' }}>
                {' '}
                تعداد نمایش در هر صفحه:
              </div>
              <Select
                open={openSize}
                onClose={handleCloseSelect}
                className={classes.showCount}
                onOpen={() => setOpenSize(true)}
                value={filtersValues.size}
                onChange={handleChangeSizePage}
              >
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={20}>20</MenuItem>
                <MenuItem value={50}>50</MenuItem>
                <MenuItem value={100}>100</MenuItem>
              </Select>
            </FormControl>
          )}
        </Grid>
        <Grid xs={12} sm={6} container item direction="row-reverse">
          {props.inventoryItems && (
            <>
              <Pagination
                count={Math.ceil(
                  props.inventoryItemsCount / filtersValues.size
                )}
                color="secondary"
                page={filtersValues.page + 1}
                onChange={handleChangePage}
              />
              <PaginationNumber onChange={handleChangePageNum} />
            </>
          )}
        </Grid>
      </Grid>
      <Grid xs={12} style={{ marginTop: '30px' }} container justify="flex-end">
        <Button
          aria-label="register-parcel"
          onClick={getInventoryItemsWithStatus}
          variant="contained"
          color="secondary"
        >
          <span className="">{'تایید تطابق محموله'}</span>
          <Icon path={mdiChevronLeft} size={1} />
        </Button>
      </Grid>
      <Dialog
        fullWidth
        open={openRegisterItems}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10,
            }}
          >
            {handleClose ? (
              <IconButton aria-label="close" onClick={handleClose}>
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>
          <div className={classes.allocateIcon}>
            <Icon path={mdiCheck} size={4} color={theme.palette.blue.main} />
          </div>
          <div>
            {id !== -1 || props.inventoryItemsWithSerial.length === 0 ? (
              <div>
                {` از
            تغییر وضعیت کالا با شناسه
            "${id}"
            به
            "${product.status === 'REGISTERED' ? 'تطبیق نشده' : 'تطبیق شده'}"
          مطمئن هستید؟`}
              </div>
            ) : (
              <div>
                <Grid
                  style={{ marginBottom: '15px' }}
                  container
                  alignItems="center"
                >
                  <Grid item xs={12} sm={4}>
                    <div className={classes.item}>
                      <span className={classes.label}>
                        <Icon
                          path={mdiArchiveOutline}
                          size={1}
                          className={classes.icon}
                        />
                        {'نام کالا :  '}
                      </span>
                      <span>
                        {props.inventoryItemsWithSerial[0]?.productName}
                      </span>
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <div className={classes.item}>
                      <span className={classes.label}>
                        <Icon
                          path={mdiKeyOutline}
                          size={1}
                          className={classes.icon}
                        />
                        {'شناسه کالا :  '}
                      </span>
                      <span>
                        {props.inventoryItemsWithSerial[0]?.productId}
                      </span>
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <div className={classes.item}>
                      <span className={classes.label}>
                        <Icon
                          path={mdiCounter}
                          size={1}
                          className={classes.icon}
                        />
                        {'تعداد :  '}
                      </span>
                      <span>{props.inventoryItemsWithSerial[0]?.amount}</span>
                    </div>
                  </Grid>
                </Grid>
                <div className={classes.cancelTitle}>
                  {` از
            تغییر وضعیت کالا با مشخصات بالا
            به تطبیق شده
          مطمئن هستید؟`}
                </div>
              </div>
            )}
          </div>
        </DialogTitle>
        <DialogActions>
          <Grid container spacing={1}>
            <Grid item xs={8}>
              <Button
                fullWidth
                autoFocus
                onClick={handleClose}
                variant="contained"
                color="secondary"
                size="large"
              >
                {'خیر'}
              </Button>
            </Grid>

            <Grid item xs={4}>
              <Button
                onClick={handleAllocateUserFunc}
                fullWidth
                variant="contained"
                size="large"
              >
                {'بله'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
      <Dialog
        fullWidth
        open={openDialogForChangeParcelStatus}
        onClose={handleCloseDialogForChangeParcelStatus}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10,
            }}
          >
            {handleCloseDialogForChangeParcelStatus ? (
              <IconButton
                aria-label="close"
                onClick={handleCloseDialogForChangeParcelStatus}
              >
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>
          <div className={classes.editIcon}>
            <Icon path={mdiCheck} size={4} color={theme.palette.blue.main} />
          </div>
          <div className={classes.cancelTitle}>
            {` از 
            تغییر وضعیت محموله به تطبیق شده
          مطمئن هستید؟`}
          </div>
        </DialogTitle>
        <DialogActions>
          <Grid container spacing={1}>
            <Grid item xs={8}>
              <Button
                fullWidth
                autoFocus
                onClick={handleCloseDialogForChangeParcelStatus}
                variant="contained"
                color="secondary"
                size="large"
              >
                {'خیر'}
              </Button>
            </Grid>

            <Grid item xs={4}>
              <Button
                onClick={e => handleSetParcelStatusFunc('REGISTERED')}
                fullWidth
                variant="contained"
                size="large"
              >
                {'بله'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
      <Dialog
        fullWidth
        open={openDialogForItemsNotRegistered}
        onClose={handleCloseDialogForItemsNotRegistered}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10,
            }}
          >
            {handleCloseDialogForItemsNotRegistered ? (
              <IconButton
                aria-label="close"
                // className={classes.closeButton}
                onClick={handleCloseDialogForItemsNotRegistered}
              >
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>
          <div className={classes.allocateIcon}>
            <Icon path={mdiCheck} size={4} color={theme.palette.blue.main} />
          </div>
          <div className={classes.cancelTitle}>
            {props.inventoryItemsWithStatus.length > 1 ? (
              <div>
                {`تعداد 
                "${props.inventoryItemsWithStatus.length}"
                آیتم از کالاها
                مانند آیتم با مشخصات 
              "${'نام کالا'} : ${props.inventoryItemsWithStatus[0]?.productName
                  }  - ${'شناسه کالا'} : ${props.inventoryItemsWithStatus[0]?.productId
                  }"
              هنوز تطبیق داده نشده است.`}
              </div>
            ) : (
              <div>
                {`آیتم با شناسه 
                "${props.inventoryItemsWithStatus[0]?.id}"
                هنوز تطبیق داده نشده است.`}
              </div>
            )}
            <div>
              <Grid>
                <TextField
                  fullWidth
                  id="description"
                  name="description"
                  autoFocus
                  rows={3}
                  value={description}
                  onChange={e => setDescription(e.target.value)}
                  label="توضیحات"
                />
              </Grid>
            </div>
          </div>
        </DialogTitle>
        <DialogActions>
          <Grid container spacing={1}>
            <Grid item xs={8}>
              <Button
                fullWidth
                autoFocus
                onClick={handleCloseDialogForItemsNotRegistered}
                variant="contained"
                color="secondary"
                size="large"
              >
                {'بررسی مجدد'}
              </Button>
            </Grid>

            <Grid item xs={4}>
              <Button
                onClick={e => handleSetParcelStatusFunc('CONFLICTED')}
                fullWidth
                variant="contained"
                size="large"
              >
                {'ایجاد مغایرت'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
      <Dialog
        fullWidth
        open={openItemsNotFound}
        onClose={handleCloseItemsNotFound}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10,
            }}
          >
            {handleCloseItemsNotFound ? (
              <IconButton
                aria-label="close"
                // className={classes.closeButton}
                onClick={handleCloseItemsNotFound}
              >
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>
          <div className={classes.allocateIcon}>
            <Icon path={mdiAlertCircle} size={4} color="#faa320" />
          </div>
          <div className={classes.cancelTitle}>
            {`آیتم مورد نظر با سریال 
            " ${getValues().serial} "
            یافت نشد.`}
          </div>
        </DialogTitle>
        <DialogActions>
          <Grid container justify="flex-end">
            <Button
              autoFocus
              onClick={handleCloseItemsNotFound}
              variant="contained"
              color="secondary"
              size="large"
            >
              {'باشه'}
            </Button>
          </Grid>
        </DialogActions>
      </Dialog>
      <Modal
        maxWidth="lg"
        onClose={() => setOpenBarcode(false)}
        open={openBarcode}
        title={
          <div>
            <Icon
              path={mdiPackageVariantClosed}
              size={4}
              color={theme.palette.green.main}
            />
          </div>
        }
        content={
          <form onSubmit={handleSubmit(checkSerial)}>
            <Grid container>
              <Grid xs={12}>
                <div style={{ width: '100%', marginBottom: '30px' }}>
                  <TextField
                    fullWidth
                    autoFocus
                    id="serial"
                    name="serial"
                    label="سریال"
                    inputRef={register({ required: true })}
                    error={errors.serial && true}
                  />
                </div>
              </Grid>
              <Grid xs={12} container justify="flex-end">
                <Button
                  variant="contained"
                  color="secondary"
                  type="submit"
                  size="large"
                  startIcon={<Icon path={mdiTextBoxSearch} size={1} />}
                  disabled={watch('serial')?.length === 0}
                >
                  {'یافتن کالا'}
                </Button>
              </Grid>
            </Grid>
          </form>
        }
      />

      <Modal
        maxWidth="xl"
        onClose={handleClosePrintModal}
        open={printModal}
        title={
          <div style={{ textAlign: 'center' }}>
            <Icon path={mdiPrinter} size={4} color={theme.palette.green.main} />
          </div>
        }
        content={
          <Grid container>
            <Grid xs={12} style={{ marginBottom: '20px', marginTop: '20px' }}>
              <LabelList
                selected={selected}
                handleSelectAllClick={handleSelectAllClick}
                handleClick={handleClick}
                data={props.inventoryItems?.filter(
                  el => el.status !== 'REGISTERED'
                )}
              />
            </Grid>
            <Box mb={4} />
            <Grid xs={12} container justify="flex-end">
              <Button
                disabled={selected.length < 1}
                variant="contained"
                color="secondary"
                size="large"
                onClick={handleClickPrint}
                startIcon={<Icon path={mdiPrinter} size={1} />}
              >
                {'پرینت سریال‌ها'}
              </Button>
            </Grid>
          </Grid>
        }
      />
    </div>
  );
};

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  parcel: makeSelectParcel(),
  inventoryItems: makeSelectInventoryItemsList(),
  inventoryItemsCount: makeSelectInventoryItemsCount(),
  loading: makeSelectLoading(),
  inventoryItemsLoading: makeSelectInventoryItemsLoading(),
  error: makeSelectError(),
  inventoryItemsError: makeSelectInventoryItemsError(),
  inventoryItemsWithSerialLoading: makeSelectInventoryItemsWithSerialLoading(),
  inventoryItemsWithSerial: makeSelectInventoryItemsWithSerialList(),
  inventoryItemsWithSerialError: makeSelectInventoryItemsWithSerialError(),
  inventoryItemsWithStatusLoading: makeSelectInventoryItemsWithStatusLoading(),
  inventoryItemsWithStatus: makeSelectInventoryItemsWithStatusList(),
  inventoryItemsWithStatusError: makeSelectInventoryItemsWithStatusError(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    getParcelWithIdActionDispatch: (id: number) =>
      dispatch(getParcelsWithIdAction({ id })),
    getParcelInventoryItemsActionDispatch: (payload: Record<string, any>) =>
      dispatch(getParcelInventoryItemsAction(payload)),
    getInventoryItemsWithSerialActionDispatch: (payload: Record<string, any>) =>
      dispatch(getInventoryItemsWithSerialAction(payload)),
    getInventoryItemsWithStatusActionDispatch: (payload: Record<string, any>) =>
      dispatch(getInventoryItemsWithStatusAction(payload)),
    updateInventoryItemsStatusDispatch: (id: number) =>
      dispatch(updateInventoryItemsActions(id)),
    updateParcelsStatusDispatch: (payload: {
      id: number;
      body: object;
      pagination: object;
      callback?: () => void;
    }) => dispatch(updateParcelsStatusActions(payload)),
    updateMultiInventoryItemsStatusDispatch: (payload: multiStatusBody) =>
      dispatch(updateMultiInventoryItemsStatusAction(payload)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(Details);
